import SyosEvents from './utils/SyosEvents';
import SyosUiContainer from './SyosUiContainer';
import syosMediaQuery from './utils/syosMediaQuery';
import { loadModal } from '../AsyncLoader';
import SyosGlobalConfig from './SyosGlobalConfig';
import SyosLegendRenderer from './SyosLegendRenderer';
import dom from '../utils/dom';
import SyosPageComponent from './SyosPageComponent';

/** @typedef {import("./SyosController").default} SyosController */
/** @typedef {import("../tnew/currency/CurrencyFormatter").default} CurrencyFormatter */


const Class = {
  DESKTOP_CONTAINER: 'tn-syos-legend__desktop-container',
  DESKTOP_HEADING: 'tn-syos-legend__desktop-heading',
  BTN_SHOW_LEGEND: 'tn-syos-legend__btn-show-legend',
  BTN_SHOW_LEGEND_MOBILE: 'tn-syos-legend__btn-show-legend-mobile',
  BTN_CLOSE_LEGEND: 'tn-syos-legend__btn-close-legend',
  DRAWER: 'tn-syos-legend__legend-drawer',
};

const html = `
  <button type="button" class="${Class.BTN_SHOW_LEGEND}"></button>
  <button type="button" class="${Class.BTN_SHOW_LEGEND_MOBILE}"></button>
  <div class="${Class.DRAWER}">
    <button type="button" class="tn-modal__btn-close ${Class.BTN_CLOSE_LEGEND}" aria-label="Close Legend"></button>
    <div class="${Class.DESKTOP_CONTAINER}">
      <div class="tn-syos-legend__desktop-heading-wrapper">
        <h3 class="${Class.DESKTOP_HEADING}"></h3>
      </div>
    </div>
  </div>
`;


class SyosLegend extends SyosUiContainer {
  isLegendExpanded = false;

  /**
   * @param {SyosController} syosController
   * @param {CurrencyFormatter} currencyFormatter
   */
  constructor(syosController, currencyFormatter) {
    super(syosController, '.tn-syos-legend__container');

    this.legendRenderer = new SyosLegendRenderer(currencyFormatter);

    this.isLegendExpanded = SyosGlobalConfig.isLegendExpandedByDefault;

    this.hide();

    this.$el.html(html);
    this.$desktopContainer = this.find(`.${Class.DESKTOP_CONTAINER}`);
    this.$btnShowLegend = this.find(`.${Class.BTN_SHOW_LEGEND}`);
    this.$btnShowLegendMobile = this.find(`.${Class.BTN_SHOW_LEGEND_MOBILE}`);
    this.$btnCloseLegend = this.find(`.${Class.BTN_CLOSE_LEGEND}`);
    const $heading = this.find(`.${Class.DESKTOP_HEADING}`);
    const $drawer = this.find('.tn-syos-legend__legend-drawer');

    this.$btnShowLegend.on('click', () => { this.onBtnOpen(); });
    this.$btnCloseLegend.on('click', () => { this.onBtnClose(); });

    this.$btnShowLegendMobile.on('click', () => { this.openLegendModal(); });

    $drawer[0].addEventListener('transitionend', (event) => {
      if (event.propertyName === 'right') {
        this.syosController.emit(SyosEvents.LEGEND_DRAWER_TRANSITION_END);
      }
    });

    this.syosController.on(SyosEvents.SCREEN_UPDATED, this.onScreenUpdated);
    this.syosController.on(SyosEvents.SEAT_LIST_DATA_LOADED, this.onSeatListDataLoaded);
    this.syosController.on(SyosEvents.LEGEND_DETAILS_SHOW, this.showLegendDetails);

    syosMediaQuery.on(SyosEvents.TABLET_ENTER, this.onTabletEnter);
    syosMediaQuery.on(SyosEvents.TABLET_LEAVE, this.onTabletLeave);

    const { legendLabel } = SyosPageComponent;

    this.$btnShowLegend.html(legendLabel);
    this.$btnShowLegendMobile.html(legendLabel);
    $heading.html(legendLabel);
  }

  onSeatListDataLoaded = ({ seatList }) => {
    const dataService = this.syosController.getDataService();

    const legendData = dataService.getLegendData(seatList);

    if (this.$currentLegend) {
      dom.remove(this.$currentLegend);
    }

    this.$currentLegend = this.legendRenderer.render(legendData);

    this.show();

    this.showLegendDetails();
  }

  onBtnOpen() {
    this.isLegendExpanded = true;
    this.syosController.emit(SyosEvents.LEGEND_DETAILS_SHOW);

    this.$btnCloseLegend.removeAttr('tabindex');
  }

  onBtnClose() {
    this.isLegendExpanded = false;
    this.syosController.emit(SyosEvents.LEGEND_DETAILS_HIDE);

    this.$btnShowLegend.focus();
    this.$btnCloseLegend.attr('tabindex', -1);
  }

  showLegendDetails = () => {
    this.$desktopContainer.append(this.$currentLegend);
  }

  openLegendModal = async () => {
    const Modal = await loadModal();

    this.modal = Modal.open({
      title: SyosPageComponent.legendLabel,
      bodyContents: this.$currentLegend,
      returnFocusTo: this.$btnShowLegend[0],
      root: this.syosController.$el,
      beforeClose: () => {
        this.syosController.emit(SyosEvents.LEGEND_DETAILS_HIDE);
      },
    });
  }

  onTabletEnter = () => {
    if (this.isLegendExpanded) {
      this.onBtnClose();
    }
  }

  onTabletLeave = () => {
    if (this.modal) {
      this.modal.close();
    }
  }

  onScreenUpdated = ({ screen }) => {
    if (screen) {
      if (this.isLegendExpanded && !syosMediaQuery.testIsMobile()) {
        this.onBtnOpen();
      } else {
        this.onBtnClose();
      }
    } else {
      this.syosController.emit(SyosEvents.LEGEND_DETAILS_HIDE);

      this.hide();
    }
  }

  show() {
    this.$el.show();
  }

  hide() {
    this.$el.hide();
  }
}

export default SyosLegend;



// WEBPACK FOOTER //
// ./src/syos/SyosLegend.js